// extracted by mini-css-extract-plugin
module.exports = {"input":"search-input_input__1Dg4r","icon":"search-input_icon__jp0vH"};